import React from 'react';
import { TableCell, TableHead, TableRow, Typography, TableBody, Table, Alert, useMediaQuery, Stack, Box } from '@mui/material';
import { CheckCircleOutline } from '@mui/icons-material';
import __t from '../lib/traduzioni';
import useBSSLogger from "../hooks/useBSSLogger";
import { grey } from '@mui/material/colors'; 
import { useTheme } from '@emotion/react';

const {logger} = useBSSLogger();

const tableStyle = {}

const headerStyle = {border: 1}

const rowHeaderStyle = {
    borderTop: `2px solid`,
    borderTopColor: `primary.main`                        
}

const bodyStyle = {
    "& .MuiTableRow-root:nth-of-type(odd)":{
        background: grey[200]
    },
    "& .MuiTableRow-root:last-of-type":{
        borderBottom: `2px solid`,
        borderBottomColor: "primary.main"
    }
}

const rowStyle = {"& .MuiTableCell-root": {border: 1}};

const keyCellStyle = {borderRight: "none !important"};

const valueCellStyle = {fontWeight: "bold", textAlign: "right", borderLeft: "none !important"}

const defaultStyles = {
    headerStyle, 
    rowHeaderStyle,
    bodyStyle,
    rowStyle,
    keyCellStyle,
    valueCellStyle
}

const defaultViewRenderer = (v) => v !== true ? v : <CheckCircleOutline color="success" />

const TabelleEntries = ({
    tabelle, 
    customHeader = null, 
    customRowHeader = null, 
    customBody = null,
    customRow = null,
    customKeyCell = null,
    customValueCell = null,    
    customEmpty = null,
    wrapped = false, 
    wrapperProps = null,
    skipRowCriteria = ([k, v]) => ![null, undefined, '', false].includes(v),
    emptyLabel = __t("nessunelemento"),
    valueHandlers = null,
    dataSource = null,
}) => {

    const theme = useTheme();
    const isPhone = useMediaQuery(theme.breakpoints.down("md"));

    const WrapperComp = wrapped ? Table : React.Fragment
    wrapperProps = wrapperProps !== null ? wrapperProps : wrapped ? {size: "small", sx: tableStyle} : {};

    return Object.entries(tabelle).map(([label, datiTabella], indiceTabella) => {

        const propsCustomComponents = {
            defaultStyles,
            tabelle,
            datiTabella,
            indiceTabella,
            dataSource
        }

        const righe = Object.entries(datiTabella)
            .filter(skipRowCriteria);

        return (
            <WrapperComp key={indiceTabella} {...wrapperProps}>
                {(customHeader === null) ? (
                    <TableHead sx={headerStyle}>                    
                        {(customRowHeader === null) ? (
                            <TableRow sx={rowHeaderStyle}>
                                <TableCell>
                                    <Typography variant={"h6"} sx={{textAlign: "left"}}>
                                        {label}
                                    </Typography>
                                </TableCell>
                                <TableCell></TableCell>
                            </TableRow>
                        ) : customRowHeader({...propsCustomComponents})
                        }
                        

                    </TableHead>
                ) : customHeader({...propsCustomComponents})}
                
                {customBody === null ? (
                    <TableBody sx={bodyStyle}>
                        {!righe.length ? ( customEmpty === null ? 
                            (<TableRow key={"emptyTable"} sx={rowStyle}>
                                <TableCell colSpan={2}>
                                    <Alert severity={"info"}>
                                        {emptyLabel}
                                    </Alert>
                                </TableCell>
                            </TableRow>) : customEmpty()

                        ) : righe.map(([k, v], indice) => {

                        const propsCustomComponentsCell = {
                            ...propsCustomComponents, rowIndex: indice, key: k, value: v
                        }

                        const renderedV = (valueHandlers?.[label]?.[k] ?? defaultViewRenderer)(v)

                        return customRow === null ? 
                            !isPhone ? (
                                <TableRow key={indice} sx={rowStyle}>                                
                                    {customKeyCell === null ? (
                                        <TableCell sx={keyCellStyle} >
                                            {__t(k)}
                                        </TableCell>
                                    ): customKeyCell({...propsCustomComponentsCell})}
                                    {customValueCell === null ? (
                                        <TableCell sx={valueCellStyle}>
                                            {renderedV}
                                        </TableCell>
                                    ) : customValueCell({...propsCustomComponentsCell})}
                                    
                                </TableRow>
                            ) : (
                                <TableRow key={indice} sx={rowStyle}>                                
                                    
                                    <TableCell  colSpan={2}>
                                        <Stack > 
                                            <Box sx={keyCellStyle}>
                                                <Typography variant="subtitle2">
                                                    {__t(k)}:
                                                </Typography>
                                            </Box>
                                            <Box sx={{...valueCellStyle, textAlign: 'left'}}>
                                                {renderedV}
                                            </Box>
                                        </Stack>                                        
                                    </TableCell>                                                                       
                                    
                                </TableRow>
                            )
                            
                        : customRow({...propsCustomComponentsCell})
                    })}

                        
                        
                    </TableBody>
                ): customBody({...propsCustomComponents})}
                
            </WrapperComp>
        )
    })
}

export default TabelleEntries
export {defaultStyles}